<template>
  <v-layout row wrap>
    <v-flex xs12 md12>
      <Breadcrumbs :items="breadcrumbs" />
    </v-flex>

    <v-flex xs12 md12>
      <CardTicketDescription :ticket="ticket" :getTicket="getTicket" />
    </v-flex>

    <v-flex xs12 md12 class="mt-2">
      <ListTicketMessages :ticket=ticket />
    </v-flex>

    <v-flex xs12 md12 mt-1 v-if="!ticket.closed_at">
      <FormMessageTicket :getTicket="getTicket" />
    </v-flex>

    <v-flex xs12 md12 mt-2 v-if="ticket.closed_at && !ticket.survey_answered">
      <SatisfactionSurvey :ticket="ticket" />
    </v-flex>
  </v-layout>
</template>
<script>
import { mapActions, mapState } from 'vuex'
import Breadcrumbs from "@/components/Helpcenter/Breadcrumbs"
import SatisfactionSurvey from '@/components/Helpcenter/SatisfactionSurvey'
import FormMessageTicket from '@/components/Helpcenter/FormMessageTicket'
import ListTicketMessages from '@/components/Helpcenter/ListTicketMessages'
import CardTicketDescription from '@/components/Helpcenter/CardTicketDescription'

export default {
  components: {
    Breadcrumbs,
    SatisfactionSurvey,
    FormMessageTicket,
    ListTicketMessages,
    CardTicketDescription,
  },
  data: () => ({
    ticket: {},
    message: "",
    loading: false,
    files: []
  }),
  computed: {
    ...mapState("user", ["current_user"]),
    breadcrumbs() {
      let items = [
        { to: "/", text: "Inicio", disabled: false, exact: true },
        { to: "/centro-de-ayuda", text: "Centro de ayuda", disabled: false, exact: true },
        { to: "/centro-de-ayuda/mis-casos", text: "Mis casos", disabled: false, exact: true },
        { to: "", text: `${this.$route.params.id}`, disabled: true }
      ]

      if (this.$vuetify.breakpoint.smAndDown) items.splice(-1)
      
      return items
    }
  },
  methods: {
    ...mapActions("helpcenter", ["fetchTicket", "createMessage"]),
    async getTicket() {
      const res = await this.fetchTicket(this.$route.params.id)
      this.ticket = res
    },
    async handleCreateMessage() {
      this.loading = true
      const payload = { ticketId: this.$route.params.id, content: this.message}
      const res = await this.createMessage(payload)

      if (res.success) {
        this.message = ""
        this.getTicket()
      }
      
      this.loading = false
    },
  },
  created() {
    this.getTicket()
  },
}
</script>
<style lang="css">

.hc__rounded-card{
  border-radius: 0.5rem
}

.hc__color-open {
  color:#E8114b !important
}

.hc__color-attended {
  color: #2196f3 !important
}

.hc__color-close {
  color:#4caf50 !important
}
</style>